<template>
	<div class="ce-image ce-image-contentwidth" v-if="objectdata.imageMaxWidth">
		<div
			v-if="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
			v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
		/>
		<figure>
			<img :src="objectdata.singleSRC" alt title>
		</figure>
	</div>
	<div v-else class="ce-image">
		<div
			v-if="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
			v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
		/>
		<figure>
			<img :src="objectdata.singleSRC" alt title>
		</figure>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},
		data() {
			return {};
		}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
</style>